import { createDefaults } from '../../utils/createDefaults';
import { today } from '../../utils/date';

type TipoSiniestro = 'accidente' | 'enfermedad' | 'vacuna';

type SiniestroReq = {
  mascotaId: string;
  tipo: TipoSiniestro;
  fecha_carga: string;
  denuncia_administrativa: string;
};

export const siniestroDefaults = createDefaults<SiniestroReq>({
  tipo: '' as TipoSiniestro,
  fecha_carga: today,
  denuncia_administrativa: '',
  mascotaId: '',
});

// ======================
// RESPONSE
// ======================
type Siniestro = {
  id: string; // Identificador principal del siniestro
  mascotaId: string; // Relación con la mascota
  tipo: string;
  estado: string;
  fecha_carga: string;
  denuncia_administrativa: string;
  nombreApellidoVet: string;
  emailVet: string;
  telefonoVet: string;
  // vet_forms: VetFormFromServer[]; // Formularios asociados al siniestro
};

// ======================
// INDICACIÓN
// ======================
type Vet = {
  id: number;
  nombre: string;
  apellido: string;
  telefono: string;
  mail: string;
  tipo: string;
};

type VetForm = {
  id: number;
  diagnostico: string;
  fechaDiagnostico: string;
  fechaAtencionSegunCliente: string;
  enfermedadBase: boolean;
  motivoConsulta: string;
  estado: 'COMPLETADO' | 'PENDIENTE' | 'ENVIADO';
};

type SVF = {
  id: number;
  siniestroId: number;
  tipo: string;
  estado: 'COMPLETADO' | 'PENDIENTE' | 'ENVIADO';
  descripcionInicial: string | null;
  costo: number;
  vet: Vet;
  vetForm: VetForm;
  vetFormId: number;
};

export type { SiniestroReq, Siniestro, SVF, TipoSiniestro };
